import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const InlinePromosParagraphLoadable = loadable(
  () => import('./InlinePromosParagraph'),
  {
    resolveComponent: components => components.InlinePromosParagraph
  }
);

export const InlinePromosParagraph = WithLazyHydration(
  InlinePromosParagraphLoadable,
  {
    name: 'InlinePromosParagraph'
  }
);
